import * as React from 'preact/compat'
import cn from 'classnames'
import Api from '../../api'
import Modal from '../Modal'
import { captureFetchException, loadStylesheet, numString } from '../../common/helpers'
import formCss from '../../../css/form.pcss.json'
import buttonCss from '../../../css/buttons.pcss.json'
import v9buttonsCss from '../../../css/v9/buttons.pcss.json'
import { showToast } from '../toast'
import Loading from "../Loading";

interface PropTypes {
  userId: number,
  onClose: () => void
  reload: boolean
}

interface StateTypes {
  formValue: string,
  resultMessage?: string,
  isSending: boolean,
  resultType?: string,
  ban: boolean,
  loading: boolean,
  existingWarns: number,
}

// noinspection JSUnusedGlobalSymbols
export default class UserModerationDialog extends React.Component<PropTypes, StateTypes> {
  state: StateTypes = {
    formValue: '',
    isSending: false,
    ban: false,
    loading: true,
    existingWarns: 0
  }

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
  }

  componentDidMount() {
    this.loadWarns()
  }

  loadWarns = () => {
    Api.get({ url: `users/warns/${this.props.userId}` })
      .then(result => {
        this.setState({
          existingWarns: result.warnsCount
        })
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  submitForm = (event: React.TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()
    this.setState({
      isSending: true
    })

    const formData = new FormData(event.currentTarget)
    Api.post({ url: 'users/warn', body: formData })
      .then(result => {
        if (result.success) {
          showToast({
            type: 'success',
            text: result.message
          })
          if (this.props.reload) {
            window.location.reload()
          } else {
            this.props.onClose()
          }
          return
        }
        this.setState({
          isSending: false,
          resultType: 'error',
          resultMessage: result.message
        })
      })
      .catch(e => {
        captureFetchException(e)
        this.setState({
          isSending: false,
          resultType: 'error',
          resultMessage: 'Произошла непредвиденная ошибка. Попробуй повторить позже.'
        })
      })
  }

  handleCloseClick = () => {
    this.props.onClose()
  }

  fillForm = (event: React.TargetedEvent<HTMLSelectElement>) => {
    const formValue = event.currentTarget.value
    this.setState({
      formValue
    })
  }

  setBan = (event: React.TargetedEvent<HTMLInputElement>) => {
    const ban = event.currentTarget.checked
    this.setState({
      ban
    })
  }

  render() {
    const {
      formValue,
      resultMessage,
      resultType,
      isSending,
      ban,
      loading,
      existingWarns
    } = this.state
    const { userId } = this.props

    return <Modal showClose={true} onClose={this.handleCloseClick}>
      {resultMessage && <div className={`system-message-${resultType}`}>
        {resultMessage}
      </div>}
      <div style='margin-bottom: 24px'>
        {loading && <Loading/>}
        {!loading && (existingWarns > 0)
          && <button
            className={cn(v9buttonsCss['button'], v9buttonsCss['secondary'])}
            data-plugins='async-modal'
            data-async-modal-href={`/ajax/user/warns/${userId}`}
          >
            У пользователя {existingWarns + ' ' + numString(existingWarns, ['замечание', 'замечания', 'замечаний'])}
          </button>}
        {!loading && existingWarns === 0 && <span>У пользователя нет замечаний</span>}
      </div>
      <form className={formCss['form-aligned']} onSubmit={this.submitForm}>
        <input type="hidden" name="user_id" value={userId}/>
        <textarea
          name="warn_text"
          id="warn_text"
          rows={5}
          style={{ width: '100%' }}
          placeholder="Укажи причину"
          required
          className={formCss['input']}
          value={formValue}
          disabled={isSending}
          autoFocus={true}
        ></textarea>
        <select id="warn_ban" className={formCss['input']} onChange={this.fillForm} disabled={isSending}>
          <option value="" disabled selected>или выбери шаблон</option>
          <option value="Использование ненормативной лексики на страницах сайта.">Мат</option>
          <option value="Оскорбления в отношении других пользователей.">Оскорбления</option>
          <option value="Спам или реклама.">Спам или реклама</option>
          <option
            value="Некорректное оформление темы в блогах. Подробнее тут - https://stopgame.ru/site_help#kak_sozdat_blog_pomestnym_ponyatiyam"
          >
            Неверное оформление темы в блогах
          </option>
        </select>
        <styled-checkbox
          name='ban'
          label='Отправить в БАН'
          disabled={isSending}
          onChange={this.setBan}
        />
        {ban && <select name='ban_time' className={formCss['input']} disabled={isSending} required>
          <option value='' disabled selected>Длительность бана</option>
          <option value='5 days'>5 дней</option>
          <option value='1 month'>1 месяц</option>
          <option value='forever'>навсегда</option>
        </select>}
        <div style={{ display: 'flex', columnGap: '16px' }}>
          <button className={buttonCss['primary']} type="submit" name="warn_submit" disabled={isSending}>
            Готово
          </button>
          <button type="button" className={buttonCss['red']} onClick={this.handleCloseClick}>
            Отмена
          </button>
        </div>
      </form>
    </Modal>
  }
}
